import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import ConfirmForm from "../../components/forms/ConfirmForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelAssignCustomerVipStatus} from "../../actions/AccountApiActions";
import {GET_CUSTOMER_VIP_STATUS} from "../../queries/customers";
import {fromJS} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class AssignCustomerVipStatusFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.assignCustomerVipStatus({customerId: this.props.customerId})
      .then((response) => {
        if (response.data.assignCustomerVipStatus.errors.length <= 0) {
          this.props.cancelAssignCustomerVipStatus();
        } else {
          let errors = createValidationErrors(response.data.assignCustomerVipStatus.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelAssignCustomerVipStatus();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let customer = fromJS(data.customer);

    if (customer.get("vip") === true) {
      return (
        <ConfirmForm
          message="This customer is already a VIP."
          onSubmit={this.handleCancel.bind(this)}
          showCancel={false}
          errors={this.state.errors}
          />
      )
    }

    return (
      <ConfirmForm
        message="Assigning VIP status to a customer will give all their accounts similar qualities to a subscriber. The prices for one-time products will be the same as the price for a subscription. Do you want to proceed?"
        submitLabel="Proceed"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        errors={this.state.errors}
        />
    )
  }
}

const ASSIGN_CUSTOMER_VIP_STATUS = gql`
  mutation assignCustomerVipStatus($data: CustomerIdInput!) {
    assignCustomerVipStatus(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(GET_CUSTOMER_VIP_STATUS, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        customerId: props.customerId
      }
    })
  }),
  graphql(ASSIGN_CUSTOMER_VIP_STATUS, {
    props: ({ mutate }) => ({
      assignCustomerVipStatus: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelAssignCustomerVipStatus})(withQueries(AssignCustomerVipStatusFormContainer));
